"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoluntaryExcessWidget = void 0;
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var React = require("react");
var Types_1 = require("../../../Types");
var core_1 = require("@athena-portal/core");
var VoluntaryExcessWidget = exports.VoluntaryExcessWidget = /** @class */ (function (_super) {
    __extends(VoluntaryExcessWidget, _super);
    function VoluntaryExcessWidget(props) {
        var _this = _super.call(this, props) || this;
        var vehicle = _this.bindFromField("vehicles[".concat(_this.props.vehicleIndex, "]"));
        _this.state = {
            vehicle: vehicle,
            showEditVoluntaryExcessSection: false
        };
        _this.editVoluntaryExcess = _this.editVoluntaryExcess.bind(_this);
        _this.saveVoluntaryExcess = _this.saveVoluntaryExcess.bind(_this);
        return _this;
    }
    VoluntaryExcessWidget.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "voluntaryExcess-widget" },
                React.createElement("div", { className: "inner-content excess mt-4" },
                    React.createElement("span", null, "Compulsory excess"),
                    React.createElement("span", { className: "float-right" },
                        "\u00A3",
                        this.state.vehicle.lvVehicleData.adFtExcess)),
                React.createElement("div", { className: "inner-content excess" },
                    React.createElement("span", null, "Voluntary excess"),
                    React.createElement("span", { className: "float-right" },
                        "\u00A3",
                        this.state.vehicle.excesses.voluntaryExcess)),
                React.createElement("div", { className: "inner-content excesses mt-0" },
                    React.createElement("div", { className: "excessSummary" },
                        React.createElement("b", null, "Total excess"),
                        React.createElement("b", { className: "float-right" },
                            "\u00A3",
                            this.props.totalAd))),
                React.createElement("form", null,
                    React.createElement("div", { className: "panel-detail-output-entity" },
                        React.createElement("button", { type: "button", className: "btn btn-white", onClick: this.editVoluntaryExcess }, "Edit voluntary excess"))),
                this.state.showEditVoluntaryExcessSection &&
                    React.createElement("div", { id: "editSection" + this.state.vehicle.registrationNumber },
                        React.createElement("div", { className: "inner-content" },
                            React.createElement("div", null,
                                "Select the amount you would like to put towards your ",
                                React.createElement("b", null, "voluntary excess"),
                                ". You can go up to \u00A3500."),
                            React.createElement("div", { className: "amount-text" }, "Voluntary excess amount (\u00A3)"),
                            React.createElement("div", { className: "radioButton" },
                                React.createElement("label", { id: "excess-label-".concat(this.state.vehicle.registrationNumber, "-amount-0") },
                                    React.createElement("input", { type: "radio", name: "excess" + this.state.vehicle.registrationNumber, value: "0" }),
                                    React.createElement("span", { className: "radio" }, "\u00A30")),
                                React.createElement("label", { id: "excess-label-".concat(this.state.vehicle.registrationNumber, "-amount-100") },
                                    React.createElement("input", { type: "radio", name: "excess" + this.state.vehicle.registrationNumber, value: "100" }),
                                    React.createElement("span", { className: "radio" }, "\u00A3100")),
                                React.createElement("label", { id: "excess-label-".concat(this.state.vehicle.registrationNumber, "-amount-200") },
                                    React.createElement("input", { type: "radio", name: "excess" + this.state.vehicle.registrationNumber, value: "200" }),
                                    React.createElement("span", { className: "radio" }, "\u00A3200")),
                                React.createElement("label", { id: "excess-label-".concat(this.state.vehicle.registrationNumber, "-amount-300") },
                                    React.createElement("input", { type: "radio", name: "excess" + this.state.vehicle.registrationNumber, value: "300" }),
                                    React.createElement("span", { className: "radio" }, "\u00A3300")),
                                React.createElement("label", { id: "excess-label-".concat(this.state.vehicle.registrationNumber, "-amount-400") },
                                    React.createElement("input", { type: "radio", name: "excess" + this.state.vehicle.registrationNumber, value: "400" }),
                                    React.createElement("span", { className: "radio" }, "\u00A3400")),
                                React.createElement("label", { id: "excess-label-".concat(this.state.vehicle.registrationNumber, "-amount-500") },
                                    React.createElement("input", { type: "radio", name: "excess" + this.state.vehicle.registrationNumber, value: "500" }),
                                    React.createElement("span", { className: "radio" }, "\u00A3500"))),
                            React.createElement("div", null, "You can set your voluntary excess to zero to reduce how much you have to pay out in the event of a claim, or you can increase it. Increasing the voluntary excess may reduce your monthly price, but will increase your total excess.")),
                        React.createElement("form", null,
                            React.createElement("button", { type: "button", className: "btn btn-white", onClick: this.saveVoluntaryExcess }, "Save voluntary excess"))))));
    };
    VoluntaryExcessWidget.prototype.editVoluntaryExcess = function () {
        this.setState({ showEditVoluntaryExcessSection: true });
    };
    VoluntaryExcessWidget.prototype.saveVoluntaryExcess = function () {
        var radios = document.getElementsByName("excess" + this.state.vehicle.registrationNumber);
        for (var i = 0, length_1 = radios.length; i < length_1; i++) {
            // @ts-ignore
            if (radios[i].checked && this.props.interaction.vehicles) {
                // @ts-ignore
                this.state.vehicle.excesses.voluntaryExcess = parseInt(radios[i].value);
                this.props.onStateChange("vehicles[".concat(this.props.vehicleIndex, "].excesses.voluntaryExcess"), this.state.vehicle.excesses.voluntaryExcess);
                this.changelogRecorder.record(this.props.engine.getInteraction(), "change", "vehicles[".concat(this.props.vehicleIndex, "].excesses.voluntaryExcess"), this.props.page && this.props.page.pageId);
                this.setState(this.state.vehicle);
                this.executeEvent("change");
                this.props.onSave(parseInt(radios[i].value));
                break;
            }
        }
        this.setState({ showEditVoluntaryExcessSection: false });
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.ChangelogRecorder),
        __metadata("design:type", Object)
    ], VoluntaryExcessWidget.prototype, "changelogRecorder", void 0);
    return VoluntaryExcessWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=VoluntaryExcessWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/motor/VoluntaryExcessWidget.js
// module id = 1078
// module chunks = 0